import { useAxios } from "../axiosConfig";

const DeviceApi = () => {
    const axiosConfig = useAxios();

    const getDeviceList = async (data, langId) => {
        try {
            const response = await axiosConfig.post(
                `/management/device/list`,
                data, // ✅ body gửi xuống BE
                {
                    headers: {
                        langId
                    }
                }
            );
            return response;
        } catch (error) {
            throw error;
        }
    };

    const getDeviceListDetailUser = async (data, langId) => {
        try {
            const response = await axiosConfig.post(
                `/management/device/list/detail/user`,
                data, // ✅ body gửi xuống BE
                {
                    headers: {
                        langId
                    }
                }
            );
            return response;
        } catch (error) {
            throw error;
        }
    };

    const getDeviceDetail = async (data, langId) => {
        try {
            const response = await axiosConfig.post(
                `/management/device/detail`,
                data,
                {
                    headers: {
                        'Content-Type': 'application/json', // ✅ FIX
                        langId
                    }
                }
            );
            return response;
        } catch (error) {
            throw error;
        }
    };

    // const getDeviceListAll = async () => {
    //     try {
    //         const response = await axiosConfig.get(`/management/device/list`);
    //         return response;
    //     } catch (error) {
    //         throw error;
    //     }
    // };


    const getDevice = async (deviceCode) => {
        try {
            const response = await axiosConfig.get(`/management/device/${deviceCode}`);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const addDevice = async (data) => {
        try {
            const response = await axiosConfig.post('/management/addDevice', data);
            return response;
        } catch (error) {
            throw error;
        }
    };


    return { getDevice, getDeviceList, getDeviceDetail, addDevice, getDeviceListDetailUser }
}

export default DeviceApi 